export default {
    imageDashboardTransaction: {
        action: 'Actie',
        transactionId: 'Transaction Id',
        variationCount: 'Variatie Berekening',
        date: 'Datum',
        description: 'Description',
        selectedImage: 'Selected Image',
        goTo: 'Go naar',
    },
};
